module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-points-left-2e326c26d33970a1982af333c418658d.svg";